<div class="container">
  <ui-toast></ui-toast>
  <app-menu class="menu"></app-menu>

  <div class="login">
    <div class="login-container">
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="login-fields">
          <div class="login-fields-item">
            <div class="login-fields-item-label" data-testid="email-label">{{ 'LOGIN.EMAIL' | transloco }}</div>
            <ui-email-field
              data-testid="email-input"
              class="login-fields-item"
              formControlName="email">
            </ui-email-field>
          </div>

          <div class="login-fields-item">
            <div class="login-fields-item-label" data-testid="password-label">{{ 'LOGIN.PASSWORD' | transloco }}</div>
            <ui-password-field
              data-testid="password-input"
              class="login-fields-item"
              formControlName="password">
            </ui-password-field>
          </div>
        </div>

        <div class="login-actions">
          <div class="login-actions-item" data-testid="remember-me">
            <ui-checkbox class="login-actions-item-icon" [(value)]="rememberMe"></ui-checkbox>
            {{ 'LOGIN.REMEMBER' | transloco }}
          </div>
          <a data-testid="forgot-password-link" class="login-actions-item link" routerLink="/forgot-password">{{ 'LOGIN.FORGOT' | transloco }}</a>
        </div>
  
        <div class="login-buttons">
          <ui-button
            data-testid="submit-btn"
            class="login-buttons-button"
            type="submit"
            [loading]="isLoggingIn">
            {{ 'LOGIN.TITLE' | transloco }}
          </ui-button>
          <shared-core-external-login data-testid="google-login-btn" (loginFailed)="onGoogleLoginFailed()" />
        </div>
      </form>
    </div>
  </div>

  <div class="bottom">
    <span class="bottom-text" data-testid="sign-up-label">{{ 'LOGIN.BOTTOM.TEXT1' | transloco }}</span>
    <a data-testid="book-demo-link" class="bottom-link">{{ 'LOGIN.BOTTOM.TEXT2' | transloco }}</a>
  </div>
</div>
